import { getContentDictionary } from "@/content/i18n/dictionaries";
import type { Locale } from "@/lib/i18n/config";

export type Pillar = {
  tag: string;
  body: string;
  icon: "Layers" | "Ecommerce" | "RefreshCw";
};

export type LeadershipEntry = {
  type: "person" | "team";
  name: string;
  role: string;
  body: string;
  linkedin?: string;
  avatar?: string;
};

export type AboutContent = {
  meta: {
    title: string;
    description: string;
    openGraphDescription: string;
  };
  hero: {
    eyebrow: string;
    title: string;
    subtitle: string;
    body: string;
  };
  purpose: {
    eyebrow: string;
    title: string;
    body: string;
  };
  pillars: {
    eyebrow: string;
    items: Pillar[];
  };
  timeline: {
    eyebrow: string;
    title: string;
    items: Array<{
      year: string;
      title: string;
      body: string;
    }>;
  };
  leadership: {
    eyebrow: string;
    title: string;
    linkedInLabel: string;
    linkedInAriaLabelTemplate: string;
    entries: LeadershipEntry[];
  };
  hub: {
    eyebrow: string;
    body: string;
    locationName: string;
    logoAlt: string;
    partnerHref: string;
  };
  closing: {
    eyebrow: string;
    title: string;
    body: string;
  };
};

export function getAbout(locale: Locale): AboutContent {
  return getContentDictionary(locale).about as AboutContent;
}

export const about = getAbout("en");
